import { ChargeDetailEntity } from "domain/entity/ChargeDetailMaintenance/ChargeDetailEntity";
import { ChargeQtyAdjSearchCriteria } from "domain/entity/ChargeQtyAdj/ChargeQtyAdjSearchCriteria";
import { ChargeDetailRepository } from "domain/repository/ChargeDetailMaintenance/ChargeDetailRepo";
import { ChargeQtyAdjRepository } from "domain/repository/ChargeQtyAdj/ChargeQtyAdjRepo";
import { CreditNoteDetailModel } from "presentation/model/CreditNote/CreditNoteDetailModel";
import { Dispatch, SetStateAction } from "react";
import BaseViewModel from "../BaseViewModel";


interface CreditNoteDetailVesselVMProps extends BaseViewModel {
    dispatch: [
        Dispatch<SetStateAction<CreditNoteDetailModel>> | ((value: SetStateAction<CreditNoteDetailModel>) => void),
    ],
    chargeDetailRepo: ChargeDetailRepository,
    repo: ChargeQtyAdjRepository,

}

export const CreditNoteDetailVesselVM = ({ dispatch, chargeDetailRepo, repo
}: CreditNoteDetailVesselVMProps) => {
    const [creditNoteDetailDispatch] = dispatch;

    const closeCntrCompDialog = () => {
        creditNoteDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: false,
                creditNoteDetailState: {
                    ...prevState.creditNoteDetailState,
                    isRead: !prevState.isShowFindVesselPanel,
                }
            }
        })
    }

    const onShowPanel = () => {
        creditNoteDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: true,
                creditNoteDetailState: {
                    ...prevState.creditNoteDetailState,
                    isRead: !prevState.isShowFindVesselPanel,
                }
            }
        })
    }

    const initSearch = async (vesselSearchCriteria: ChargeQtyAdjSearchCriteria) => {
        repo.getConVslVoyForChargeQtyAdj(vesselSearchCriteria).then((data) => {
            creditNoteDetailDispatch(prevState => {
                return {
                    ...prevState,
                    creditNoteDetailVessels: data
                }
            })
        })
    }

    const apply = async (selectedRows: ChargeDetailEntity[]) => {
        creditNoteDetailDispatch(prevState => {
            return {
                ...prevState,
                isShowFindVesselPanel: false,
                creditNoteDetailState: {
                    ...prevState.creditNoteDetailState,
                    editingHeader: {
                        ...prevState.creditNoteDetailState.editingHeader,
                        consortiumCode: selectedRows[0]?.consortiumCode !== undefined ? selectedRows[0]?.consortiumCode : null,
                        vesselCode: selectedRows[0]?.vesselCode !== undefined ? selectedRows[0]?.vesselCode : null,
                        voyageCode: selectedRows[0]?.voyageCode !== undefined ? selectedRows[0]?.voyageCode : null,
                        vesselName: selectedRows[0]?.vesselName !== undefined ? selectedRows[0]?.vesselName : null,
                        etb: selectedRows[0]?.arrDatetime !== undefined ? selectedRows[0]?.arrDatetime : null,
                        etd: selectedRows[0]?.depDatetime !== undefined ? selectedRows[0]?.depDatetime : null,
                        operatingTml: selectedRows[0]?.operatingTml !== undefined ? selectedRows[0]?.operatingTml : null,
                        // serviceCode: selectedRows[0]?.serviceCode !== undefined ? selectedRows[0]?.serviceCode : null,
                        // soa: selectedRows[0]?.soa !== undefined ? selectedRows[0]?.soa : null,
                        slVesselCode: selectedRows[0]?.slVesselCode !== undefined ? selectedRows[0]?.slVesselCode : null,
                        slObVoyageCode: selectedRows[0]?.slObVoyageCode !== undefined ? selectedRows[0]?.slObVoyageCode : null,
                        slIbVoyageCode: selectedRows[0]?.slIbVoyageCode !== undefined ? selectedRows[0]?.slIbVoyageCode : null,
                    },
                    isRead: !prevState.isShowFindVesselPanel,
                }
            }
        })
    }

    const coVslVoy = async (selectedRows: ChargeDetailEntity[]) => {
        creditNoteDetailDispatch(prevState => {
            return {
                ...prevState,
                creditNoteDetailState: {
                    ...prevState.creditNoteDetailState,
                    editingHeader: {
                        ...prevState.creditNoteDetailState.editingHeader,
                        consortiumCode: selectedRows[0]?.consortiumCode !== undefined ? selectedRows[0]?.consortiumCode : null,
                        vesselCode: selectedRows[0]?.vesselCode !== undefined ? selectedRows[0]?.vesselCode : null,
                        voyageCode: selectedRows[0]?.voyageCode !== undefined ? selectedRows[0]?.voyageCode : null,
                    },
                }
            }
        })
    }

    const updateSelectedCreditNoteDetails = (rows: any[]) => {
        creditNoteDetailDispatch(prevState => {
            return {
                ...prevState,
                selectedCreditNoteDetailVesselRow: rows
            }
        })
    }

    return {
        onShowPanel: onShowPanel,
        initSearch: initSearch,
        apply: apply,
        coVslVoy: coVslVoy,
        closeCntrCompDialog: closeCntrCompDialog,
        updateSelectedCreditNoteDetails: updateSelectedCreditNoteDetails
    }
}


